// TODO use primary tailwind colors!
export const COLOR_OK =  '#4AB890';
export const COLOR_STARTED = '#1A22E4'; 
export const COLOR_PAUSED = '#FDA906';
export const COLOR_ERROR = '#D94F46';
export const COLOR_GRAY = '#A1B3C1';
